module.exports = __webpack_public_path__ + "static/img/6981_phase_function_Paper_Points.a91ad1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6981_phase_function_Paper_Points.png
// module id = yBdS
// module chunks = 0